// pages/SubscriptionCanceled/SubscriptionCanceled.js
import { useNavigate } from "react-router-dom";
import CTAs from "../components/CTAs";

const SubscriptionCanceled = () => {
  const navigate = useNavigate();

  const handleTryAgain = () => {
    sessionStorage.removeItem("pendingRegistration");
    navigate("/register");
  };

  return (
    <div className="w-full min-h-screen bg-neutrals-neutral-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-xl shadow-lg p-8 text-center">
        <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <svg
            className="w-8 h-8 text-yellow-600"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
            />
          </svg>
        </div>
        <h2 className="text-2xl font-bold text-neutrals-neutral-900 mb-2">
          Payment Canceled
        </h2>
        <p className="text-neutrals-neutral-600 mb-6">
          Your payment was canceled. No charges were made to your account. You
          can try again when you're ready.
        </p>
        <div className="space-y-3">
          <CTAs
            type="Gradientbtn"
            text="Try Again"
            width="w-full"
            onClick={handleTryAgain}
          />
          <CTAs
            type="Secondarybtn"
            text="Back to Login"
            width="w-full"
            onClick={() => navigate("/login")}
          />
        </div>
        <p className="text-xs text-neutrals-neutral-400 mt-6">
          Need help?{" "}
          <a
            href="mailto:support@yourapp.com"
            className="text-primary-primary-500 hover:underline"
          >
            Contact support
          </a>
        </p>
      </div>
    </div>
  );
};

export default SubscriptionCanceled;
